// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Yts0","location":"Header_location__20-P8"};